import 'react-toastify/dist/ReactToastify.css';
import '@tools/window';
import './fonts.css';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { useBrowserTitle } from '@shared/hooks/useBrowserTitle';
import { routesConfig } from '@tools/routes';
import { observer } from 'mobx-react';
import * as React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { ToastContainer } from 'react-toastify';

import { theme } from './app-theme';
import ErrorBoundary from './error-boundary';
import { Fallback } from './fallback';

const AppRouter = () => {
    const router = createBrowserRouter(routesConfig);
    return <RouterProvider router={router} />;
};

export const App = observer(() => {
    useBrowserTitle('Home');
    return (
        <>
            <ErrorBoundary>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <ToastContainer />
                    <main>
                        <React.Suspense fallback={<Fallback />}>
                            <AppRouter />
                        </React.Suspense>
                    </main>
                </ThemeProvider>
            </ErrorBoundary>
        </>
    );
});
